import React from "react";
import back from "../../asset/landing_images/landing-phonebg.webp";
import backMobile from "../../asset/landing_images/landing-smallone.webp";

const LandingHands = () => {
  const isMobile = window.innerWidth <= 768;
  const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;

  const handSectionStyle = {
    height: "100%",
    backgroundImage: `url(${isMobile ? backMobile : back})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    // border:'2px solid red'

  };

  const textContainerStyle = {
    paddingTop: isMobile ? "3rem" : isTablet ? "4rem" : "7rem",
    display: "flex",
    flexDirection: "column",
    marginLeft: isMobile ? "auto" : isTablet ? "25rem" : "50rem",
    marginRight:isMobile ? "auto" : "2rem",
    textAlign: isMobile ? "center" : "left",
    // margin:isMobile ?  "0 auto" : "",
    // border:'2px solid red',
    height: isMobile ?'auto':'45%',

  };

  return (
    <div style={{ height: isMobile ? "85rem": "75rem", marginTop: "5rem" }}>
      <div style={handSectionStyle}>
        <div style={textContainerStyle}>
          <h2
            style={{
              fontWeight: 700,
              color: "#fff",
              fontSize: isMobile ? "2.5rem" : "3rem",
            }}
          >
            Bringing <br /> YouthPlus into <br /> your hands
          </h2>
          <p style={{ fontWeight: "400", color: "#fff" }}>
            YouthPlus on the go. Enjoy convenience and <br /> accessibility on
            whatever device of your <br /> choice
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingHands;
